/**
 * Asks the admin shell to switch section: `detail` is the section id.
 *
 * Sections render into a host element and know nothing of the shell's tab bar,
 * so a cross-section action (the Players tab's "Invoice" button) announces the
 * switch instead of reaching into index.ts.
 */
export const ADMIN_SECTION_EVENT = 'tb:admin-section';
